import React, { Fragment, useEffect, useState } from 'react';

import icons from './../../../icons.svg';
import CalibrationProductDrawer from './calibrationProductDrawer';
import { Button } from '../../common/utils';
import * as cabinetActions from './../../../actions/cabinet';
import * as planogramActions from './../../../actions/planogram';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import ConfirmModal from '../modals/confirmModal';

const MIN_SLOT_PRODUCTS_COUNT = 3;
const MAX_SLOT_PRODUCTS_COUNT = 9;

const ProductSlotAssignment = ({
  t,
  cabinet,
  shelfNumber,
  slotData,
  allProducts,
  setCalibrationData,
  cabinetActions,
  planogramActions,
}) => {
  const [selectedProduct, setSelectedProdduct] = useState({});
  const [showProductDrawer, setShowProductDrawer] = useState();
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  useEffect(() => {
    const { products, productAssigned } = slotData;

    const productId = productAssigned || products[0];
    const product = allProducts.find(p => p.id === productId) || {};
    setSelectedProdduct({
      id: product.id,
      barcode: product.barcode,
      name: product.name,
      imageUrl: product.imageUrl,
      count: MIN_SLOT_PRODUCTS_COUNT,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * when user clicks +/- for the amount of product put in slot
   * @param {*} type plus | minus
   * @returns
   */
  const handleProductCountChange = type => {
    if (type === 'plus') {
      setSelectedProdduct(prevState => {
        return {
          ...prevState,
          count:
            prevState.count >= MAX_SLOT_PRODUCTS_COUNT
              ? MAX_SLOT_PRODUCTS_COUNT
              : prevState.count + 1,
        };
      });
    } else {
      if (selectedProduct.count <= 0) return;
      setSelectedProdduct(prevState => {
        return {
          ...prevState,
          count:
            prevState.count <= MIN_SLOT_PRODUCTS_COUNT
              ? MIN_SLOT_PRODUCTS_COUNT
              : prevState.count - 1,
        };
      });
    }
  };

  /**
   * if user puts the product count direclty in the input field
   * @param {number} countValue
   */
  const handleInputAmountChanged = countValue => {
    setSelectedProdduct(prevState => ({ ...prevState, count: countValue }));
  };

  /**
   * send command to save selected data when user confirsm
   */
  const saveCalibrationData = () => {
    setCalibrationData({
      product: selectedProduct?.id,
      count: selectedProduct.count,
    });
    cabinetActions.initialShelfSlotEnd(
      cabinet.deviceCode,
      shelfNumber,
      slotData.slot,
      selectedProduct.id,
      selectedProduct.count
    );

    planogramActions.updatePlanogram(
      allProducts.find(product => product.id === selectedProduct?.id),
      shelfNumber,
      slotData.slot
    );
  };

  return (
    <div className="calibration__product">
      <ConfirmModal
        isOpen={openConfirmModal}
        close={confirm =>
          confirm ? saveCalibrationData() : setOpenConfirmModal(false)
        }
        message={t('common:confirmCalibrationProduct', {
          count: selectedProduct.count,
        })}
        t={t}
      />
      <div className="calibration__product-info">
        <div className="calibration__instruction-cabinet">{cabinet.name}</div>
        <div className="calibration__selected">
          <span className="calibration__selected-shelf">
            {t('common:shelf')}: {shelfNumber}
          </span>
          <span className="calibration__selected-slot">
            {t('common:slot')}: {slotData.slot}
          </span>
        </div>
      </div>

      <div
        className="calibration__product-bubble"
        onClick={() => setShowProductDrawer(true)}
      >
        {selectedProduct.barcode && (
          <div className="calibration__product-container">
            <div className="calibration__product-bubble-content">
              {selectedProduct.imageUrl && (
                <img src={selectedProduct.imageUrl} alt="product" />
              )}
              {!selectedProduct.imageUrl && (
                <svg>
                  <use xlinkHref={`${icons}#icon-cube`}></use>
                </svg>
              )}
              <div className="calibration__product-bubble-edit">
                <svg>
                  <use xlinkHref={`${icons}#icon-upload`}></use>
                </svg>
              </div>
            </div>
            <div className="calibration__product-bubble-name">
              {selectedProduct.name}
            </div>
            <div className="calibration__product-bubble-barcode">
              {selectedProduct.barcode}
            </div>
          </div>
        )}

        {!selectedProduct.barcode && (
          <div className="calibration__product-bubble-content">
            {t('selectProduct')}
            <div className="calibration__product-bubble-edit">
              <svg>
                <use xlinkHref={`${icons}#icon-upload`}></use>
              </svg>
            </div>
          </div>
        )}
      </div>

      {selectedProduct.barcode && (
        <Fragment>
          <div className="calibration__product-input">
            <button onClick={() => handleProductCountChange('minus')}>
              {' '}
              -{' '}
            </button>
            <input
              type="numnber"
              min={MIN_SLOT_PRODUCTS_COUNT}
              max={MAX_SLOT_PRODUCTS_COUNT}
              value={selectedProduct.count}
              disabled={true}
              onChange={e => handleInputAmountChanged(e.target.value)}
            />
            <button onClick={() => handleProductCountChange('plus')}>
              {' '}
              +{' '}
            </button>
          </div>
          <div className="calibration__instruction-text">
            {t('common:placeProducts')}
          </div>
          <div className="calibration__product-save">
            <Button
              type="save"
              text={t('save')}
              onClick={() => {
                setOpenConfirmModal(true);
              }}
            />
          </div>
        </Fragment>
      )}

      <CalibrationProductDrawer
        products={allProducts || []}
        t={t}
        shelf={shelfNumber}
        slot={slotData.slot}
        showProductDrawer={showProductDrawer}
        closeProductDrawer={state => setShowProductDrawer(state)}
        productSelection={product => {
          setSelectedProdduct({
            id: product.id,
            barcode: product.barcode,
            name: product.name,
            imageUrl: product.imageUrl,
            count: MIN_SLOT_PRODUCTS_COUNT,
          });
          setShowProductDrawer(false);
        }}
        selectedProduct={selectedProduct}
      />
    </div>
  );
};

const mapStateToProps = ({ cabinet }) => ({
  cabinet,
});

const mapActionToProps = dispatch => ({
  cabinetActions: bindActionCreators(cabinetActions, dispatch),
  planogramActions: bindActionCreators(planogramActions, dispatch),
});

// export default ProductSlotAssignment;

export default connect(
  mapStateToProps,
  mapActionToProps
)(translate()(ProductSlotAssignment));
